/**
 * OP Progress Scales: RPE valid input is exertion selection (1..10) or comments.
 */
export const isRpeScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "rpe";

export const hasRpeAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  const v = data.exertion;
  if (v == null || v === "") return false;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) && n >= 1 && n <= 10;
};

